// extracted by mini-css-extract-plugin
export var container = "index-module--container--5oUpm";
export var footer = "index-module--footer--iu+-8";
export var footerSponsorLogo = "index-module--footerSponsorLogo--s+LXx";
export var footerLogo = "index-module--footerLogo--h41Uw";